<div class="wetter_content_container">

  <mat-horizontal-stepper labelPosition="bottom" [linear]="false" #stepper="matHorizontalStepper">
    <ng-template matStepperIcon="edit">
      <mat-icon>my_location</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="done">
      <mat-icon>my_location</mat-icon>
    </ng-template>


    <ng-container *ngFor="let i of let region of regionenBericht?.regionsListe">
      <mat-step>
        <ng-template class="mat-step-header" matTooltip="{{region?.name}}"
                     matStepLabel>{{capitalizeFirstLetter(region?.name)}}</ng-template>
        <div class="bericht-text-container">
          <h2>{{capitalizeFirstLetter(region?.name)}}</h2>
          <h3>Zusammenfassung</h3>
          {{region?.zusammenfassung}}
          <h3>Vorhersagen</h3>
          <span class="bericht-text-sub-label"><b>Heute</b></span>
          {{region?.vorhersageHeute}}
          <span class="bericht-text-sub-label"><b>Kommende Nacht</b></span>
          {{region?.vorhersageKommendeNacht}}
          <div class="bericht-text-container">
            <h3>Aussichten</h3>
            <span class="bericht-text-sub-label">{{region?.aussichten?.tag01?.datum | date: 'EEE dd.MM.yyyy'}}</span>
            {{region?.aussichten?.tag01?.text}}
            <span class="bericht-text-sub-label">{{region?.aussichten?.tag02?.datum | date: 'EEE dd.MM.yyyy'}}</span>
            {{region?.aussichten?.tag02?.text}}
            <span class="bericht-text-sub-label">{{region?.aussichten?.tag03?.datum | date: 'EEE dd.MM.yyyy'}}</span>
            {{region?.aussichten?.tag03?.text}}
            <span class="bericht-text-sub-label">{{region?.aussichten?.tag04?.datum | date: 'EEE dd.MM.yyyy'}}</span>
            {{region?.aussichten?.tag04?.text}}
          </div>
          <div class="bericht-text-container">
            <h3>TV Prognose</h3>
            {{region?.tvPrognose}}
          </div>
          <div class="bericht-text-container">
            <h3>7-Tage Trend</h3>
            {{region?.siebenTageTrend}}
          </div>
        </div>
      </mat-step>
      <!--  Hier Dateiname noch -->
    </ng-container>
  </mat-horizontal-stepper>


</div>
